<template>
    <Flow :app="app" />
</template>

<script>
import ANALYTICS from '@generio-ai/library-legacy/constants/analytics'
import APPS from '@generio-ai/library-legacy/constants/apps'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import Flow from '@/components/flow/Flow.vue'

export default {
    name: 'ViewModify',
    components: {
        Flow
    },
    computed: {
        app() {
            return APPS.MODIFY
        }
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('overlay', [
            'hide'
        ]),
    },
    mounted() {
        this.hide()
        this.logEvent({
            name: ANALYTICS.EVENTS.VIEW_OPENED,
            description: 'Modify view opened',
        })
    }
}
</script>